import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { mainMockup } from '../data/media';
export function BonusSection() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-19" data-mp="22fwlwjc8sb7a">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="22dah2rgqk9sr">
        <div className="text-center" data-id="element-21" data-mp="1ydru7q5ctona">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-raspberry" data-id="element-22" data-mp="1yetcaeksfbei">
            5 Professional Bonus Guides
          </p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-23" data-mp="15pw454aaiuzh">
            Get 5 Professional Bonus Guides Completely{' '}
            <span className="text-raspberry" data-id="element-24" data-mp="1jivekrv7tz06">FREE</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-cocoa" data-id="element-25" data-mp="1eohien8qbnug">
            Included at no additional cost when you get Pastry Instructor Ready
            today.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="myczyu4j5avv">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-2xl border border-champagne bg-cream-light p-6 shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-27" data-mp="29q0dmxv1u281" data-mpi={index}>
              <div className="flex items-center gap-2 text-champagne-deep" data-id="element-28" data-mp="20qvd5lzxfyt8">
                <GiftIcon size={18} aria-hidden="true" data-id="element-29" data-mp="25qhua6ivlz7b" />
                <span className="text-xs font-bold uppercase tracking-[0.14em] text-raspberry" data-id="element-30" data-mp="25s2mvqlmr82j">
                  Bonus {bonus.id}
                </span>
              </div>
              <h3 className="mt-3 font-serif text-2xl font-semibold leading-snug text-espresso" data-id="element-31" data-mp="3h4vacp7e1acs">
                {bonus.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-cocoa" data-id="element-32" data-mp="1h5hz2s44k0jc">
                {bonus.description}
              </p>
              <div className="mt-auto pt-6" data-id="element-33" data-mp="1q43e4dae0xfd">
                <p className="inline-flex rounded-full bg-raspberry-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-raspberry" data-id="element-34" data-mp="1q2scok4f01rf">
                  Included free
                </p>
              </div>
            </motion.article>)}
        </div>
        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-35" data-mp="te2rajtkwr0p">
          <img src={mainMockup} alt="The 5 Pastry Instructor Ready bonus guides" loading="lazy" className="mx-auto w-full max-w-2xl drop-shadow-xl" data-id="element-36" data-mp="tbq3hq153mfq" />
          <p className="mt-6 text-sm font-bold uppercase tracking-[0.16em] text-espresso sm:text-base" data-id="element-37" data-mp="12co8obnbdzzw">
            5 Professional Teaching Resources —{' '}
            <span className="text-raspberry" data-id="element-38" data-mp="amjskp6l7z4h">Included Free</span>
          </p>
        </div>
      </div>
    </section>;
}